module.exports = __webpack_public_path__ + "static/ChoccyRatings-08cdd44305e78a85ffaa05fa733cd0e2.svg";